import { useState, useEffect, useMemo } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { FiSearch, FiX } from "react-icons/fi";
import VehicleCard from "../VehicleCard";
import React from "react";
import { scroller } from "react-scroll";
import FinancingCarousel from "./FinancingCarousel";
import useFinanciaciones from "../../config/useFinanciaciones";
import loading from "../../assets/loading.svg";
import { buildRouteWithUtms, saveUtmParams } from "../../config/whatsappConfig";
import "./VehicleListToolbar.scss";

const matchesModelSearch = (item, tipoKey, query) => {
  const term = query.trim().toLowerCase();
  if (!term) return true;

  const info = item[tipoKey];
  if (!info) return false;

  const modelo = (info.modelo || "").toLowerCase();
  const version = (info.version || "").toLowerCase();
  return modelo.includes(term) || version.includes(term);
};

const VehicleList = ({ vehicles }) => {
  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);
  const [modelSearch, setModelSearch] = useState("");

  let history = useHistory();
  let location = useLocation();
  let { tipo } = useParams();

  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();

  useEffect(() => {
    const validTipos = ["todos", "convencional", "plan", "preventa"];
    const search = location.search;

    if (!tipo || !validTipos.includes(tipo)) {
      saveUtmParams();
      history.replace(buildRouteWithUtms("/todos", search));
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const handleTipo = (e) => {
    setTipoSearch(e);
    saveUtmParams();
    scroller.scrollTo("scroll-click", { smooth: true, duration: 400, offset: -10 });
  };

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  const filtradosConvencional = useMemo(
    () =>
      vehicles
        .filter((item) => item.convencional.habilitado === true)
        .filter((item) => matchesModelSearch(item, "convencional", modelSearch))
        .sort((a, b) => a.convencional.prioridad - b.convencional.prioridad),
    [vehicles, modelSearch],
  );

  const filtradosPlan = useMemo(
    () =>
      vehicles
        .filter((item) => item.plan.habilitado === true)
        .filter((item) => matchesModelSearch(item, "plan", modelSearch))
        .sort((a, b) => a.plan.prioridad - b.plan.prioridad),
    [vehicles, modelSearch],
  );

  const filtradosPreventa = vehicles.filter((item) => item?.preventa?.habilitado === true);

  const isSearching = Boolean(modelSearch.trim());
  const showConvencional =
    (tipoSearch === "convencional" || tipoSearch === "todos" || isSearching) &&
    (!isSearching || filtradosConvencional.length > 0);
  const showPlan =
    (tipoSearch === "plan" || tipoSearch === "todos" || isSearching) &&
    (!isSearching || filtradosPlan.length > 0);
  const noSearchResults =
    isSearching && filtradosConvencional.length === 0 && filtradosPlan.length === 0;

  // aqui guardamos los datos de utms

  /* sessionStorage.setItem('saludo', 'Bienvenidos a localStorage');
  valor = sessionStorage.getItem('saludo');
  */

  return (
    <>
      <div id="scroll-click" className="vehicle-list-toolbar pt-4 pb-4">
        <div className="vehicle-list-toolbar-inner">
          <div className="vehicle-list-toolbar-buttons">
            <button
              type="button"
              className={`btn btn-blue_white ${(tipoSearch === "convencional" || tipoSearch === "todos") && "active"}`}
              onClick={() => handleTipo("convencional")}
            >
              Venta directa
            </button>
            <button
              type="button"
              className={`btn btn-blue_white ${tipoSearch === "plan" && "active"}`}
              onClick={() => handleTipo("plan")}
            >
              Plan de Ahorro
            </button>
          </div>
          <div className="vehicle-list-search">
            <FiSearch className="vehicle-list-search__icon" aria-hidden="true" />
            <input
              type="search"
              className="vehicle-list-search__input"
              placeholder="Buscar modelo..."
              value={modelSearch}
              onChange={(e) => setModelSearch(e.target.value)}
              aria-label="Buscar modelo"
            />
            {modelSearch ? (
              <button
                type="button"
                className="vehicle-list-search__clear"
                onClick={() => setModelSearch("")}
                aria-label="Borrar búsqueda"
              >
                <FiX aria-hidden="true" />
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {noSearchResults ? (
        <p className="text-center py-4 vehicle-list-empty-search w-100">No encontramos modelos con ese nombre.</p>
      ) : null}

      {showConvencional ? (
        <div id="convencional">
          <div className="vehicle-list-section-header">
            <Container>
              <Row>
                <Col>
                  {" "}
                  <h2 className="vehicle-list-section-title text-center">
                    ¡Llevate tu vehiculo en Montironi por <b>Venta Directa</b>!
                  </h2>
                </Col>
              </Row>
            </Container>
          </div>

          <Row className="d-flex">
            {filtradosConvencional.length > 0 ? (
              filtradosConvencional.map((item, index) => (
                <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                  <VehicleCard
                    info={item}
                    tipo={tipoSearch}
                    filtrados={filtradosConvencional}
                    nombreTipo="convencional"
                    todosLosVehiculos={vehicles}
                  />
                </Col>
              ))
            ) : (
              <p className="text-center py-4 vehicle-list-empty-search w-100">
                {modelSearch.trim()
                  ? "No encontramos modelos con ese nombre."
                  : "Proximamente más opciones disponibles."}
              </p>
            )}
          </Row>

          {loadingFinanciaciones ? (
            <Row className="d-flex justify-content-center mb-4 mt-2">
              <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
            </Row>
          ) : financiaciones && financiaciones.length > 0 ? (
            <div id="financiaciones" className="financing-section">
              <p className="financing-section-subtitle">Financiá por Venta Directa</p>
              <FinancingCarousel financiaciones={financiaciones} />
            </div>
          ) : null}
        </div>
      ) : null}

      {showPlan ? (
        <div className={tipoSearch === "plan" && !isSearching ? null : "mt-4"} id="plan">
          <div className="vehicle-list-section-header">
            <Container>
              <Row>
                <Col>
                  {" "}
                  <h2 className="vehicle-list-section-title text-center">
                    ¡Llevate tu vehiculo en Montironi por <b>Plan de Ahorro</b>!
                  </h2>
                </Col>
              </Row>
            </Container>
          </div>
          <Row className="d-flex">
            {filtradosPlan.length > 0 ? (
              filtradosPlan.map((item, index) => (
                <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                  <VehicleCard
                    info={item}
                    tipo={tipoSearch}
                    filtrados={filtradosPlan}
                    nombreTipo="plan"
                    todosLosVehiculos={vehicles}
                  />
                </Col>
              ))
            ) : (
              <p className="text-center py-4 vehicle-list-empty-search w-100">
                {modelSearch.trim()
                  ? "No encontramos modelos con ese nombre."
                  : "Proximamente más opciones disponibles."}
              </p>
            )}
          </Row>
        </div>
      ) : null}

      {/*
      {tipoSearch === "preventa" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "preventa" ? null : "mt-5"} id="preventa">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">Futuros Vehículos</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPreventa && filtradosPreventa.length > 0 ? (
              filtradosPreventa
                .sort((a, b) => a.preventa.prioridad - b.preventa.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPreventa}
                      nombreTipo="preventa"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}
      */}
    </>
  );
};

export default VehicleList;

